import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { compose } from 'redux';
import { useParams } from 'react-router-dom';

import store from '../../store';
import { membershipsRestHooks } from '../../store/FastCash/MembershipsSlice';
import { membershipRestHooks } from '../../store/FastCash/MembershipSlice';
import { useFetchStatus } from '../../utils/fetchStatusUtils';
import Memberships from '../../pages/Memberships';
import ListSkeleton from '../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../pages/constants';

const MembershipsContainer = () => {
  const { fastCashId } = useParams();
  const {
    loadMemberships,
    loadResetMemberships,
    memberships: { loadingStatus, items: memberships, meta },
  } = membershipsRestHooks.use();

  const {
    createMembership,
    updateMembership,
    membership: { errors },
  } = membershipRestHooks.use();

  const { isFulfilled } = useFetchStatus(loadingStatus);

  const handleMembershipCreate = async () => {
    await createMembership(fastCashId);
    loadMemberships(fastCashId);
  };

  const handleMembershipUpdate = async (...params) => {
    await updateMembership(fastCashId, ...params);
    loadMemberships(fastCashId);
  };

  useEffect(() => {
    loadMemberships(fastCashId);
    return () => {
      loadResetMemberships();
    };
  }, []);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  return (
    <Memberships
      fastCashId={fastCashId}
      memberships={memberships}
      meta={meta}
      apiErrors={errors}
      onMembershipCreate={handleMembershipCreate}
      onMembershipUpdate={handleMembershipUpdate}
      onMembershipsLoad={loadMemberships}
      onLoadMemberships={loadMemberships}
    />
  );
};

const addStore = (ProxyComponent) => (props) =>
  (
    <Provider store={store}>
      <ProxyComponent {...props} />
    </Provider>
  );

export default compose(addStore)(MembershipsContainer);
